import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import FullScreenLoader from "../components/FullScreenLoader";

export default function ProtectedAdminRoute({ children, requiredPermission }) {
  const [role, setRole] = useState(null);
  const [rolePermissions, setRolePermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    const fetchProfileAndPermissions = async () => {
      try {
        const profileRes = await axios.get(`${BASE_URL}/api/admin/profile`, {
          withCredentials: true,
        });
        const admin = profileRes.data;
        const roleName = admin?.role;

        const rolesRes = await axios.get(`${BASE_URL}/api/admin-roles`, {
          withCredentials: true,
        });

        const matchedRole = rolesRes.data.find((r) => r.name === roleName);
        const permissions = matchedRole?.permissions || [];

        setRole(roleName);
        setRolePermissions(permissions);
      } catch (err) {
        setRole(null);
        setRolePermissions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileAndPermissions();
  }, [BASE_URL]);

  if (loading) return <FullScreenLoader />;
  if (!role) return <Navigate to="/admin-login" />;

  // ⬇️ Allow superadmin to access everything
  if (role !== "superadmin" && !rolePermissions.includes(requiredPermission)) {
    return <Navigate to="/admin/dashboard" />;
  }

  return children;
}

